export enum PackageSettingsEvent {
  OnUseCustomFolderChange = 'onUseCustomFolderChange',
}
